import React from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import Button from "@material-ui/core/Button";
import { PropTypes } from "prop-types";
import JurisdictionFormOneContainer from "../../../Container/DataEntry/DataEntryOne_MainWorkflow/Forms/JurisdictionFormOneContainer";
import JurisdictionFormTwoContainer from "../../../Container/DataEntry/DataEntryOne_MainWorkflow/Forms/JurisdictionFormTwoContainer";
import JurisdictionFormThreeContainer from "../../../Container/DataEntry/DataEntryOne_MainWorkflow/Forms/JurisdictionFormThreeContainer";
import JurisdictionFormFourContainer from "../../../Container/DataEntry/DataEntryOne_MainWorkflow/Forms/JurisdictionFormFourContainer";
import { Card, CardContent, StepButton } from "@material-ui/core";
import { makeStyles } from "@mui/styles";
import JurisdictionFormCodeContainer from "../../../Container/DataEntry/DataEntryOne_MainWorkflow/Forms/JurisdictionFormCodeContainer";
import JurisdictionFormFiveContainer from "../../../Container/DataEntry/DataEntryOne_MainWorkflow/Forms/JurisdictionFormFiveContainer";
import { GetSet } from "../../../Constants/Jurisdiction";

const buttonUseStyles = makeStyles({
  root: {
    marginLeft: "1em",
  },
});

const topCardUseStyles = makeStyles({
  root: {
    marginBottom: "2em",
  },
});

const JurisdictionEditDisplay = (props) => {
  let {
    steps,
    step,
    data,
    releaseJurisdiction,
    removeJurisdiction,
    codeTypes,
    codeStart,
    lastStep,
    renderKey,
    setHeaderTitle,
  } = props;
  const buttonClasses = buttonUseStyles();
  const topCardClasses = topCardUseStyles();

  let offset = 0;
  if (step.get !== 0) {
    offset = step.get - 1;
  }

  setHeaderTitle(data.get.name);

  return (
    <React.Fragment>
      {data.get && (
        <React.Fragment>
          <Card classes={{ root: topCardClasses.root }}>
            <CardContent>
              {step.get === 0 && (
                <JurisdictionFormOneContainer key={renderKey} data={data} />
              )}
              {step.get === 1 && (
                <JurisdictionFormTwoContainer key={renderKey} data={data} />
              )}
              {step.get === 2 && (
                <JurisdictionFormThreeContainer key={renderKey} data={data} />
              )}
              {step.get === 3 && (
                <JurisdictionFormFourContainer key={renderKey} data={data} />
              )}
              {step.get === 4 && (
                <JurisdictionFormFiveContainer key={renderKey} data={data} />
              )}
              {step.get >= codeStart &&
                step.get < codeStart + codeTypes.length && (
                  <JurisdictionFormCodeContainer
                    key={renderKey}
                    data={data}
                    codeType={codeTypes[step.get - codeStart]}
                  />
                )}
            </CardContent>
          </Card>
          <Card>
            <CardContent>
              <Stepper nonLinear activeStep={step.get}>
                {steps.slice(offset, offset + 3).map((label, index) => {
                  return (
                    <Step key={label} active={index === step.get - offset}>
                      <StepButton completed={index < 1 && step.get !== 0}>
                        {label}
                      </StepButton>
                    </Step>
                  );
                })}
              </Stepper>
              <Button
                onClick={() => step.set(step.get - 1)}
                disabled={step.get === 0}
                variant="contained"
              >
                Back
              </Button>
              {step.get < lastStep && (
                <Button
                  onClick={() => step.set(step.get + 1)}
                  variant="contained"
                  color="primary"
                  classes={{ root: buttonClasses.root }}
                >
                  Next
                </Button>
              )}
              <Button
                onClick={() => releaseJurisdiction()}
                variant="contained"
                color="Secondary"
                classes={{ root: buttonClasses.root }}
              >
                Release Jurisdiction
              </Button>
              {step.get === lastStep && (
                <Button
                  onClick={() => {
                    step.set(step.get + 1);
                    removeJurisdiction();
                  }}
                  variant="contained"
                  color="primary"
                  classes={{ root: buttonClasses.root }}
                >
                  Finish
                </Button>
              )}
            </CardContent>
          </Card>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

JurisdictionEditDisplay.propTypes = {
  steps: PropTypes.array.isRequired,
  step: GetSet,
  data: GetSet,
  releaseJurisdiction: PropTypes.func.isRequired,
  removeJurisdiction: PropTypes.func.isRequired,
  codes: GetSet,
  codeTypes: PropTypes.array.isRequired,
  codeStart: PropTypes.number.isRequired,
  lastStep: PropTypes.number.isRequired,
  renderKey: GetSet,
  setHeaderTitle: PropTypes.func,
};

export default JurisdictionEditDisplay;
